/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon32Regular = forwardRef('AttachLinkIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M1 16a8 8 0 0 1 8-8h4a1 1 0 1 1 0 2H9a6 6 0 0 0 0 12h4a1 1 0 1 1 0 2H9a8 8 0 0 1-8-8Z" }),
        React.createElement("path", { d: "M31 16a8 8 0 0 0-8-8h-4a1 1 0 1 0 0 2h4a6 6 0 0 1 0 12h-4a1 1 0 1 0 0 2h4a8 8 0 0 0 8-8Z" }),
        React.createElement("path", { d: "M10 15a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H10Z" })));
});
